import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=17df0452"
import script from "@/js/questionDetail.ts?vue&type=script&lang=ts&external"
export * from "@/js/questionDetail.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=17df0452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports